<template>
  <b-card class="mb-0">
    <b-row class="text-center">
      <h3 style="text-transform: uppercase">Welcome to SuperScore</h3>
    </b-row>

    <b-row class="p-2 pt-3 pb-3">
      <!-- <b-col cols :md=12>
        <h5>Step 1: Select data type</h5>
        
      </b-col> -->
    </b-row>

    <!-- <b-tabs card nav-class="pt-3 pl-2" class="tabs" v-model="tab" :key="home">
      
    </b-tabs> -->
  </b-card>
</template>

<script>
  import axios from 'axios';
  import {fullURL} from '../utils';

  export default {
    name: 'Home',

    data() {
      const F = this.$store.state.files.fileList;

      return {
        F: F
      };
    },

    computed: {
      
    },

    watch: {
      
    },

    methods: {
      
    }
  };
</script>
